import { useMemo } from 'react';

import { FilterDropdown } from '../../ui/FilterDropdown/FilterDropdown';
import {
  complianceStatusOptions,
  entityOptions,
  riskClassificationOptions,
} from './FilterSection.constants';
import { FiltersSectionProps } from './FiltersSection.types';
import { AppliedFilters } from '../../ui/AppliedFilters/AppliedFilters';

export function FiltersSection({
  selectedEntity,
  onEntityChange,
  selectedComplianceStatus,
  onComplianceStatusChange,
  selectedRiskClassification,
  onRiskClassificationChange,
  selectedOwners,
  onOwnersChange,
  selectedOrganization,
  onOrganizationChange,
  onResetFilters,
  ownerOptions = [],
  ownersLoading = false,
  organizationOptions = [],
  organizationsLoading = false,
}: FiltersSectionProps) {
  const hasActiveFilters = useMemo(() => {
    return (
      selectedEntity.length > 0 ||
      selectedComplianceStatus.length > 0 ||
      selectedRiskClassification.length > 0 ||
      selectedOwners.length > 0 ||
      selectedOrganization.length > 0
    );
  }, [
    selectedEntity,
    selectedComplianceStatus,
    selectedRiskClassification,
    selectedOwners,
    selectedOrganization,
  ]);

  return (
    <div className="flex items-center gap-2 w-full">
      <AppliedFilters />

      <div className="flex-[0.7] min-w-0">
        <FilterDropdown
          placeholder="Entity"
          options={entityOptions}
          selectedValues={selectedEntity}
          onSelectionChange={onEntityChange}
          className="w-full"
        />
      </div>

      <div className="flex-[1.2] min-w-0">
        <FilterDropdown
          placeholder="Compliance Status"
          options={complianceStatusOptions}
          selectedValues={selectedComplianceStatus}
          onSelectionChange={onComplianceStatusChange}
          className="w-full"
        />
      </div>

      <div className="flex-[1.2] min-w-0">
        <FilterDropdown
          placeholder="Risk Classification"
          options={riskClassificationOptions}
          selectedValues={selectedRiskClassification}
          onSelectionChange={onRiskClassificationChange}
          className="w-full"
        />
      </div>

      <div className="flex-[0.7] min-w-0">
        <FilterDropdown
          placeholder={ownersLoading ? 'Loading...' : 'Owner'}
          options={ownerOptions}
          selectedValues={selectedOwners}
          onSelectionChange={onOwnersChange}
          className="w-full"
        />
      </div>

      <div className="flex-[1.2] min-w-0">
        <FilterDropdown
          placeholder={organizationsLoading ? 'Loading...' : 'Organization'}
          options={organizationOptions}
          selectedValues={selectedOrganization}
          onSelectionChange={onOrganizationChange}
          className="w-full"
        />
      </div>

      <button
        className={`flex items-center gap-2 px-3 py-2 flex-shrink-0 transition-colors ${
          hasActiveFilters ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'
        }`}
        onClick={hasActiveFilters ? onResetFilters : undefined}
        disabled={!hasActiveFilters}
      >
        <span
          className={`text-xs leading-4 font-medium ${
            hasActiveFilters ? 'text-purple-800' : 'text-gray-200'
          }`}
        >
          Reset Filters
        </span>
      </button>
    </div>
  );
}
